import type { ColDef } from 'ag-grid-community';
import { SideBarDef } from 'ag-grid-community';

import { setQuickFilter } from '@/app/slices/quickFilter';
import { CustomViews } from '@/components/common/custom-views';
import { useAppDispatch, useAppSelector } from '@/components/hooks/hook';

export const defaultColDef: ColDef = {
  sortable: true,
  pivot: false,
  filter: true,
  wrapText: false,
  resizable: true,
  autoHeight: false,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  enableValue: false,
  enableRowGroup: true,
  enablePivot: false,
  menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
  filterParams: {
    maxNumConditions: 1,
  },
};

export const pivotDefaultColDef: ColDef = {
  sortable: true,
  filter: true,
  wrapText: false,
  resizable: true,
  autoHeight: false,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  enableValue: true,
  enableRowGroup: true,
  enablePivot: true,
  minWidth: 130,
};

export const defaultDetailColDef: ColDef = {
  flex: 1,
  sortable: true,
  pivot: false,
  wrapText: false,
  resizable: true,
  autoHeight: false,
  wrapHeaderText: false,
  autoHeaderHeight: true,
  suppressAutoSize: false,
};

export const defaultFreshShipmentColDef: ColDef = {
  sortable: true,
  pivot: false,
  filter: true,
  wrapText: false,
  resizable: true,
  autoHeight: false,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  enableValue: false,
  enableRowGroup: true,
  enablePivot: false,
};

export const icons = {
  'custom-views': '<span class="ag-icon ag-icon-eye"></span>',
  settings: '<span class="ag-icon ag-icon-settings"></span>',
};

export const sideBar: SideBarDef = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
    },
    {
      id: 'filters',
      labelDefault: 'Filters',
      labelKey: 'filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
    },
    {
      id: 'customViews',
      labelDefault: 'Custom Views',
      labelKey: 'customViews',
      iconKey: 'custom-views',
      toolPanel: CustomViews,
      toolPanelParams: {
        setQuickFilter,
        useAppDispatch,
        useAppSelector,
      },
    },
  ],
};

const lookupSideBarCache = new Map<string, SideBarDef>();

export const lookupSideBar = (viewContext: string): SideBarDef => {
  const cached = lookupSideBarCache.get(viewContext);
  if (cached) return cached;

  const config: SideBarDef = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
      {
        id: 'customViews',
        labelDefault: 'Custom Views',
        labelKey: 'customViews',
        iconKey: 'custom-views',
        toolPanel: CustomViews,
        toolPanelParams: {
          setQuickFilter,
          useAppDispatch,
          useAppSelector,
          viewContext,
        },
      },
    ],
  };

  lookupSideBarCache.set(viewContext, config);
  return config;
};
